import { getToken, setToken } from '~/src/dash/api/auth/auth';

export const Auth = {
  saveToken(err: any, json: any) {
    if (err) {
      setToken({});
      return json;
    }
    setToken(json);
    return json;
  },
  appendToken(body: any) {
    const token = getToken();
    return Object.assign({}, body, {
      access_token: token.access_token,
    });
  },
};
